"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BASE_64_PLACEHOLDER = exports.DEVICE_PIXEL_RATIO_LIST = void 0;
var DEVICE_PIXEL_RATIO_LIST = [1, 1.5, 2, 3, 4];
exports.DEVICE_PIXEL_RATIO_LIST = DEVICE_PIXEL_RATIO_LIST;
var BASE_64_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
exports.BASE_64_PLACEHOLDER = BASE_64_PLACEHOLDER;